var _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDoorLockout = function SvgDoorLockout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 18.333H30v63.334h40V18.333z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 58.333,
    width: 9.167,
    height: 23.333,
    rx: 4.583,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.143 57.738v-9.525l-1.31-2.341 1.31-2.341 1.31-2.341-1.31-2.341-1.31-2.341 1.31-2.341M57.5 47.5h5.833",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.333,
    y: 41.667,
    width: 33.333,
    height: 33.333,
    rx: 16.667,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 59.167a2.5 2.5 0 00-2.5 2.5v4.002a5 5 0 105 0v-4.002a2.5 2.5 0 00-2.5-2.5z",
    fill: "#F8F8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 65.669l.417.721.416-.24v-.481H27.5zm5 0h-.833v.48l.416.241.417-.721zm-4.167-4.002c0-.92.747-1.667 1.667-1.667v-1.667a3.333 3.333 0 00-3.333 3.334h1.666zm0 4.002v-4.002h-1.666v4.002h1.666zM25.833 70c0-1.541.837-2.888 2.084-3.61l-.834-1.442A5.831 5.831 0 0024.167 70h1.666zM30 74.167A4.167 4.167 0 0125.833 70h-1.666A5.833 5.833 0 0030 75.833v-1.666zM34.167 70A4.167 4.167 0 0130 74.167v1.666A5.833 5.833 0 0035.833 70h-1.666zm-2.084-3.61A4.165 4.165 0 0134.167 70h1.666a5.831 5.831 0 00-2.916-5.052l-.834 1.442zm-.416-4.723v4.002h1.666v-4.002h-1.666zM30 60c.92 0 1.667.746 1.667 1.667h1.666A3.333 3.333 0 0030 58.333V60z",
    fill: "#332C4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 52.5,
    r: 1.667,
    fill: "#332C4A"
  })));
};

export default SvgDoorLockout;